module.exports = __webpack_public_path__ + "img/p5.f0e4825c.jpg";